const CARD_DATA = [
  {
    Items: [
      {
        id: 1,
        title: "President",
        name: "MR SEYI ADEWUNMI",
        imageUrl: "./assets/images/members/LCC_PRESIDENT.JPEG",
        desc: " ",
        link: "/PRESIDENT",
      },
      {
        id: 2,
        title: "Vice President",
        name: "ENGR OLATUNJI AMOSU",
        imageUrl: "./assets/images/members/LCC_VICE_PRESIDENT.jpeg",
        link: "/VICEPRESIDENT",
        desc: "Engr Olatunji Amosu is the MD/CEO Boltons Nigeria Limited, an international outfit. He holds a Bachelor’s Degree in Public Administration from the Lagos State University, and Diploma in Biomedical Communications as well as Diploma in Computer Elect from University of Lagos, he also has a Cert in Technical Training from Terumo Europe NV, Belgium Engr Tunji Amosu is married with children and enjoys sports and social activities. He is a member of several Social Clubs and Societies and have served in various capacity in the Club, particularly Darts section where he was Entertainment officer, Secretary, Vice Chairman and Chairman.",
      },
      {
        id: 3,
        title: "Secretary General",
        name: "Mr. OLUWATOYIN DEINDE ",
        imageUrl: "./assets/images/members/LCC_SEC_GENERAL.jpg",
        desc: "Oluwatoyin Deinde is an accomplished IT and Customer Service professional with over 18 years of progressive experience in the telecommunications and banking sectors..",
        link: "/SECRETARYGENERAL",
      },
      {
        id: 4,
        title: "Hon. Treasurer",
        name: "OTUNBA ABIMBOLA OLANIYI",
        imageUrl: "./assets/images/members/LCC_TREASURER.JPEG",
        desc: "Brief Resume of Otunba Abimbola Omotunde Olaniyi-FCA, ACS, AMNIM, FRCN\n\nA fellow of the Institute of Chartered Accountants of Nigeria, an Associate Member of the Chartered Institute of Stockbrokers of Nigeria. An Associate of the Nigerian Institute of Management and also a Dealing Member of the Nigerian Stock Exchange. A Registered Dealing Clerk with the Securities and Exchange Commission. Also a Registered Member of Financial Reporting Council of Nigeria.\n\nBimbola acquired 6 years accounting training experience from (Peat Marwick, Ani, Ogunde & Co.) now KPMG Audit, 6 years as Branch Accountant and 2 years as Investment Manager with NAL Merchant Bank Plc. He also spent 6 years as a Licensed Stockbroker with Nigerian Stockbrokers Ltd (NSL) (a subsidiary of NAL Merchant Bank Plc). He left as Deputy General Manager (NSL) on 28th October, 1998.\n\nHe went into accounting practice before joining GTI Capital Ltd as Pioneer General Manager, Operations in January 2001. He was involved in staff recruitment, policy formation, and internal control system development for the firm. He also prepared an operational manual, supervised all units with emphasis on the Accounts unit, and was instrumental in establishing the Akure office. He ran the Ibadan office profitably for five months.\n\nHe traded for the firm on the floor of the Exchange, represented the firm in various fora, and worked alongside the MD/CEO. He served as Acting Managing Director of Dynamic Portfolio Ltd for about a year before moving to Support Services Ltd. as the General Manager, Investment, when the former company was technically suspended. He also traded on the Exchange floor for Support Services.\n\nHe later joined Yuderb Investment and Securities Ltd as the pioneer General Manager, Operations and Accounts. He held this role until 2019, when he moved to Topmost Securities Ltd as Finance Director, while also serving as Principal Partner at A. O. Olaniyi & Co (Chartered Accountants).\n\nHe is currently a Consultant to the State of Osun and has been a Pioneer Member of the Tax Audit Management (TAMA) in the State of Osun from 2012 to date.\n\nAll these span over three decades. Otunba Bimbola Olaniyi is widely traveled and is married with children.",
        link: "/HONTREASURER",
      },
      {
        id: 5,
        title: "Membership Secretary",
        name: "Mr. Francis Ofordu",
        imageUrl: "./assets/images/members/LCC_MEMBERSHIP_SEC.jpg",
        desc: "Mr. Francis Ofordu is a long-standing member of Lagos Country Club since 2013 and currently serves as Membership Secretary. A seasoned banking professional with over 18 years of experience, he is passionate about enhancing member engagement, upholding club standards, and driving service excellence.",
        link: "/MEMBERSHIPSECRETARY",
      },
      {
        id: 6,
        title: "Hon, Social Secretary",
        name: "MR.OSEMOJE LATO",
        imageUrl: "./assets/images/members/LCC_SOCIAL_SECRETARY.JPEG",
        desc: "Osemoje Lato was born to the family of Mr. Roland & Mrs. Beatrice Lato of Benin City, Edo State of N...",
        link: "/HONSOCIALSECRETARY",
      },
      {
        id: 7,
        title: "SPORTS SECRETARY",
        name: "Mr. VINCENT OLUSEYE OLASOGBA ",
        imageUrl: "./assets/images/members/LCC_SPORTS SECETERARY.jpg",
        desc: "Chartered Accountant. ",
        link: "/SPORTSSECRETARY",
      },
      {
        id: 8,
        title: "Hon. Council Member ",
        name: "Arc. Ashiru Tokunbo",
        imageUrl: "./assets/images/members/LCC_COUNCI_MEMBER.jpeg",
        desc: "Arc Adetokunbo Ashiru. is the MD/CEO ASHTKB VENTURES LTD He holds a B.Tech. Architecture from the Ri...",
        link: "/HONCOUNCILMEMBER",
      },
      {
        id: 9,
        title: "LEGAL ADVISER",
        name: "Barr. Sosanya Olubunmi Olaitan",
        imageUrl: "./assets/images/members/legaladvicer.jpeg",
        desc: "Barr. Sosanya Olubunmi Olaitan was Born on the 7th July, 1962. He bagged his West African School Cer...",
        link: "/LEGALADVISER",
      },
      {
        id: 10,
        title: "ACTING GENERAL MANAGER",
        name: "Mrs. THERESA KEJI",
        imageUrl: "./assets/images/members/LCC_ACTING_GM.jpg",
        desc: "",
        link: "/GENERALMANAGER",
      },
      {
        id: 11,
        title: "CHAIRMAN, SNOOKER/BILLIARDS",
        name: "MR. TOMI OLURINOLA",
        imageUrl: "./assets/images/members/LCC3.jpeg",
        desc: " ",
        link: "/CHAIRMANSNOOKER",
      },
      {
        id: 12,
        title: "CHAIRMAN, SWIMMING SECTION",
        name: "ENGR. DEJI OSHIKOYA",
        imageUrl: "./assets/images/members/LCC_SWIMMING.jpg",
        desc: "",
        link: "/CHAIRMANSWIMMING",
      },
      {
        id: 13,
        title: "CHAIRMAN, TENNIS SECTION",
        name: "MR. JOHN NWOSU",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_TENNIS.jpg",
        desc: "",
        link: "/CHAIRMANTENNIS",
      },
      {
        id: 14,
        title: "LCC CHAIRMAN DARTS",
        name: "EVANG ADEKUNBI AKIN-TAYLOR",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_DARTS.jpg",
        desc: "",
        link: "/CHAIREMANDARTT",
      },
      {
        id: 15,
        title: "CHAIRMAN, BADMINTON SECTION",
        name: "MR. OLUFEMI AZEEZ",
        imageUrl: "./assets/images/members/CHAIRMAN_BADMINTON_SECTION.JPEG",
        desc: "",
        link: "/CHAIRMANBADMINTON",
      },
      {
        id: 16,
        title: "LCC CHAIRMAN TABLE TENNIS",
        name: "MR ABIODUN BAMGBADE ",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_TABLE_TENNIS.jpg",
        desc: "Abiodun Bamgbade a passionate Table Tennis player and a sociable person who cut across all members of the Section (both old and young members) and the club general. ",
        link: "/CHAIRMANTABLE",
      },
      {
        id: 17,
        title: "LCC Chairman Squash",
        name: "MR. SESAN ASANI",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_SQUASH.JPG",
        desc: "Mr. Sesan Asani is the CEO, Conlog Logistics Services Ltd & Operations Director, Conair Cargo Services Ltd...",
        link: "/CHAIRMANSQUASH",
      },
      {
        id: 18,
        title: "LCC CHAIRMAN SCRABBLE",
        name: "Mr. Abidemi Muraina-Taiwo",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_SCRABBLE.jpg",
        desc: "...........................................................................",
        link: "/CHAIRMANSCRABBLE",
      },
      {
        id: 19,
        name: "MR. ADETAYO ADEGBOYE",
        title: "LCC AEROBICS TAKEWONDO",
        imageUrl: "./assets/images/members/LCC_AEROBICS_TAKEWONDO.JPG",
        desc: "Chairman Aerobics/Takewondo  Astute Insurance professional with passion for human capital development,professionalism and teamwork .Loves reading physical exercise and social engagement.",
        link: "/AEROBICSTAKEWONDO",
      },
      {
        id: 20,
        title: "CHAIRMAN, OTHER GAMES",
        name: "MR TUNJI AKINWANDE",
        imageUrl: "./assets/images/members/LCC_CHAIRMAN_OTHER_GAMES.jpg",
        desc: "Tunji Akinwande is currently a Director at Peers Consulting. He oversees the Finance department of Peers Consulting in addition to his Consulting job. .",
        link: "/OTHERGAME",
      },
    ],
  },
];

export default CARD_DATA;
